import React from 'react';
// import { Link } from "react-router-dom";
// import { getAllStates } from '../../index';

class SingleNextButton extends React.Component {

    // Render the Next Button on each step form, if final review is true, also shows another button to take member to the final review page
    render() {
        //var reviewCheck = getAllStates().review;
        return (
            <div className="hug loanApp-btn-wrap single-next">
                <button id="loan_app_next_button" className="next-btn button" type="submit">{this.props.nextBtnTxt}</button>
                {/* {reviewCheck && (
                    <div className="hug return-button-wrap">
                        <Link to="/loan-application/final-review/" className="next-btn button">Return to Final Review</Link>
                    </div>
                )} */}
            </div>
        )
    }
}

export default SingleNextButton;